import { Alert, Button, Card, Flex, Stack, Text } from "@mantine/core";
import { COLORS } from "../../../../constants/colorConstants";
import { useCreateFormContext } from "../createFormContext";
import { DatePicker } from "@mantine/dates";
import { getPresetsForMultipleDates } from "../../../../utils/datePickerPresetUtils";

export default function CreateFormSelectionCard() {
  return (
    <Card shadow="xs" p="md" radius="lg" mb="md" w="100%" withBorder bg={COLORS.WHEAT} c={COLORS.DARK_BROWN}>
      <CalendarInput />
    </Card>
  );
}

function CalendarInput() {
  const form = useCreateFormContext();
  const values = form.getValues();
  const presets = getPresetsForMultipleDates(values.startDate, values.endDate);
  const inputProps = form.getInputProps("selectedDates");

  return (
    <Stack>
      <Flex justify="space-between" gap="xl">
        <Text fz={16} fw={700} mt="lg">
          The dates you select will be excluded from schedules when this calendar is used by them.
        </Text>
        <Button
          variant="filled"
          w={100}
          bg={COLORS.DARK_BROWN}
          c={COLORS.WHEAT}
          onClick={() => {
            form.resetField("selectedDates");
            form.resetField("dateSettings");
          }}
        >
          Clear
        </Button>
      </Flex>
      <DatePicker
        type="multiple"
        minDate={values.startDate}
        maxDate={values.endDate}
        presets={presets}
        numberOfColumns={3}
        key={form.key("selectedDates")}
        {...form.getInputProps("selectedDates")}
        error={inputProps.error}
      />

      {inputProps.error && (
        <Alert title="Error with Selected Days" variant="filled" bg={COLORS.DARK_WINE}>
          <Text>{inputProps.error}</Text>
        </Alert>
      )}
    </Stack>
  );
}
